import { useQuery } from '@tanstack/react-query';

import { PaginationValues } from '@/hooks/usePagination';
import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse, ParamsWithPagination } from '@/types/api';

import {
  ChannelRecordingTaskAggregations,
  ChannelRecordingTaskFilters,
  ChannelRecordingTaskType,
} from '../types';

import { channelRecordingTasksKeys } from './query-keys';

export async function getChannelRecordingTasks(
  params?: ParamsWithPagination<ChannelRecordingTaskFilters>,
  paginationValues?: PaginationValues | null
): Promise<PaginatedResponse<ChannelRecordingTaskType, ChannelRecordingTaskAggregations>> {
  const { sortBy } = paginationValues || {};
  return mediaManagerClient.get('/api/v1/channel_recording_tasks', {
    params: {
      limit: params?.limit,
      offset: params?.offset,
      search: params?.search,
      state__in: params?.stateIn?.join(','),
      production_center_id__in: params?.productionCenterIdIn?.join(','),
      channel_id__in: params?.channelIdIn?.join(','),
      created_at__gte: params?.createdAtGte,
      created_at__lte: params?.createdAtLte,
      channel__media_type__in: params?.channelMediaTypeIn?.join(','),
      channel__provider__in: params?.channelProviderIn?.join(','),
      recording_task_type__in: params?.recordingTaskTypeIn?.join(','),
      order_by: sortBy?.id ? `${sortBy.id} ${sortBy.order}` : 'error_first',
    },
  });
}

type QueryFnType = typeof getChannelRecordingTasks;

interface UseSegmentsParams {
  config?: QueryConfig<QueryFnType>;
  params?: ParamsWithPagination<ChannelRecordingTaskFilters>;
  paginationValues?: PaginationValues | null;
}

export function useChannelRecordingTasks({
  config,
  params,
  paginationValues,
}: UseSegmentsParams = {}) {
  return useQuery({
    ...config,
    queryKey: channelRecordingTasksKeys.list(params),
    queryFn: () => getChannelRecordingTasks(params, paginationValues),
  });
}
